import { formatDate } from 'helpers/utils';
import React from 'react';
import { Button } from 'components/common';
import { FaTrophy } from 'react-icons/fa';
import ConvertPCVComponent from '../ConvertPCVCompenent';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

const ConvertedPCV = ({lead}) => {
  const navigate = useNavigate();
  const opportunity = lead?.opportunity || {};

 const handleGoToPCV = () => {
  navigate(`/crm/projects/${opportunity.id}`);
 }

  return (
    <div>
      <div className="tw-text-center">
        <div className="tw-my-4">
          <div className="tw-mx-auto">
            <FaTrophy className="tw-text-yellow-500" size="50" />
          </div>
        </div>
        <h4 className="tw-mb-1">Your lead has converted to PCV!</h4>
        <p className="tw-text-sm">Now you can access to your account</p>
        <Button variant="primary" className="tw-px-5 tw-my-3" onClick={handleGoToPCV}>
          Go to PCV now!
        </Button>
      </div>

      <ConvertPCVComponent lead={lead} />

      <div className="tw-text-right tw-text-xs tw-my-2">Converted by: <span className="tw-text-blue-600 tw-font-bold">{lead.convert_by}</span>, Date: <span className="tw-text-blue-600 tw-font-bold">{formatDate(lead.convert_date)}</span></div>
    </div>
  );
};

ConvertedPCV.propTypes = {
  lead: PropTypes.object.isRequired
}

export default ConvertedPCV;
